getDateFormat = function (date) {
    if (!date) {
        return '';
    }

    let d = new Date(date);

    let day = String(d.getDate()).padStart(2, '0');
    let month = String(d.getMonth() + 1).padStart(2, '0');
    let year = d.getFullYear();

    return `${year}-${month}-${day}`;
}

getDateTimeFormat = function (date) {
    if (!date) {
        return '';
    }

    let d = new Date(date);

    let day = String(d.getDate()).padStart(2, '0');
    let month = String(d.getMonth() + 1).padStart(2, '0');
    let year = d.getFullYear();
    let hours = String(d.getHours()).padStart(2, '0');
    let minutes = String(d.getMinutes()).padStart(2, '0');
    let seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

getDateUTCToLocalDate = function () {
    $('[data-utc-date]').each(function () {
        const utcDate = $(this).attr('data-utc-date');
        const localDate = new Date(`${utcDate}Z`.replace(" ", "T"));
        if (isNaN(localDate.getTime())) {
            return true; // continue to next iteration
        }
        $(this).text(localDate.toLocaleString());
    });
}
